export default class BlogContent {
    id;
    title;
    language;
    summary;
    value;
    seo_title;
    seo_tags = [];
    seo_description;

    static fromJson = (json) => {
        let content = new BlogContent();

        content.id = json.id;
        content.language = json.language;
        content.title = json.title;
        content.summary = json.summary;
        content.value = json.value != null ? json.value : '{}';

        content.seo_title = json.seo_title;
        content.seo_tags = json.seo_tags;
        content.seo_description = json.seo_description;

        return content;
    }
}